module.exports = function() {
  return new Worker(__webpack_public_path__ + "14658c66a53c19550ed7.worker.js");
};